import React from 'react';

import './Header.scss';

const Header = function Header() {
  return (
    <header className="header">
      <div className="header_main">
        <div className="header_main_container">
          <a href="/" className="logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="147"
              height="32"
              viewBox="0 0 147 32"
              className="Logo_logo__sGWNA"
            >
              <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="5.833"
                x2="24.203"
                y1="25.058"
                y2="9.777"
              >
                <stop offset="0" stopColor="#0397a7" />
                <stop offset="1" stopColor="#00eccd" />
              </linearGradient>
              <path
                d="M32.733 12.02L23.915 1.151A2.82 2.82 0 0021.281.144L7.459 2.346a2.82 2.82 0 00-2.19 1.778L.267 17.194c-.36.942-.19 2.003.444 2.785L9.53 30.846a2.82 2.82 0 002.634 1.008l13.82-2.203a2.82 2.82 0 002.19-1.778l5.004-13.067c.36-.942.19-2.004-.444-2.787z"
                fill="url(#a)"
              />
              <path
                d="M20.538 9.48l-3.129 5.598-3.075-6.645-3.84 1.023-4.757 12.397H9.98l2.86-7.312 2.82 6.965h2.171l4.172-7.466v9.55l3.96-1.34V10.445z"
                fill="#fff"
              />
              <path
                d="M49.827 10.523l-3.185 5.7-3.134-6.767-3.91 1.04-4.844 12.625h4.323l2.913-7.444 2.871 7.093h2.21l4.25-7.602v9.614l4.032-1.364V11.503zm35.056 2.043c-1.562 0-2.875.502-3.941 1.527-1.048 1.005-1.58 2.31-1.58 3.916 0 1.587.532 2.892 1.58 3.897 1.066.983 2.38 1.485 3.96 1.485s2.892-.502 3.94-1.485c1.066-1.005 1.6-2.31 1.6-3.897 0-1.606-.534-2.911-1.6-3.916-1.066-1.025-2.379-1.527-3.959-1.527zm2.12 5.442c0 1.422-.933 2.35-2.102 2.35-1.167 0-2.102-.928-2.102-2.35 0-1.441.933-2.408 2.102-2.408 1.167 0 2.103.967 2.103 2.408zm-12.465-5.432a4.57 4.57 0 01.264-.008c2.376 0 3.396 1.295 3.396 3.565v7.006h-3.842v-6.206c0-.636-.234-1.018-.721-1.018-.446 0-1.347.15-1.899.552v6.674h-3.798V12.783h3.138l.213.776c.628-.396 2.092-.943 3.25-.983zm-17.084 3.429v-2.917l.497-.089c2.962-.536 8.568-1.552 8.57 3.846v6.291h-2.907l-.219-.504s-1.025.773-3.215.773c-2.4 0-3.666-1.657-3.666-3.255 0-2.618 2.311-3.246 4.908-3.246h1.82c0-1.06-.646-1.458-2.003-1.44h.004c-1.914 0-3.446.435-3.784.54h-.005zm3.625 4.928c1.429 0 2.185-.531 2.185-1.725v-.114l-1.724-.015c-1.337 0-1.977.2-1.977.892s.564.961 1.516.961zm76.075-6.84c1.066-1.025 2.379-1.527 3.941-1.527 1.58 0 2.893.502 3.959 1.527 1.067 1.005 1.6 2.31 1.6 3.916 0 1.587-.533 2.892-1.6 3.897-1.047.983-2.361 1.485-3.941 1.485s-2.893-.502-3.959-1.485c-1.048-1.005-1.58-2.31-1.58-3.897 0-1.606.534-2.911 1.58-3.916zm3.961 6.266c1.169 0 2.102-.929 2.102-2.351 0-1.441-.935-2.408-2.102-2.408-1.169 0-2.102.967-2.102 2.408-.002 1.422.933 2.35 2.102 2.35zm-10.364-7.783c.086-.005.174-.008.263-.008 2.378 0 3.396 1.295 3.396 3.564v7.007h-3.842v-6.206c0-.636-.234-1.018-.721-1.018-.446 0-1.346.15-1.898.552v6.674h-3.799V12.783h3.139l.212.776c.628-.396 2.092-.943 3.25-.983zm-24.71-2.053l-3.187 5.7-3.132-6.767-3.91 1.04-4.844 12.625h4.32l2.914-7.445 2.873 7.094h2.21l4.248-7.603v9.615l4.034-1.364V11.503zm7.627 5.482v-2.917l.497-.089c2.962-.536 8.568-1.552 8.569 3.846v6.291h-2.906l-.219-.504s-1.025.773-3.215.773c-2.399 0-3.666-1.657-3.666-3.255 0-2.618 2.311-3.246 4.908-3.246h1.82c0-1.06-.646-1.458-2.003-1.44h.004c-1.914 0-3.446.435-3.784.54h-.005zm3.623 4.927c1.429 0 2.185-.53 2.185-1.724v-.114l-1.724-.015c-1.337 0-1.977.2-1.977.892s.564.961 1.516.961z"
                fill="#1e3c87"
              />
            </svg>
          </a>

          <div className="main_navigation">
            <div className="main_account">
              <div className="account_container">
                <button className="login_button" type="button">
                  <span className="button_label">
                    <span className="title">Hello</span>
                    <span className="description">Sign In</span>
                  </span>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    height="16"
                    role="presentation"
                    width="16"
                    viewBox="0 0 24 24"
                    className="svg_9c8206b6 LoginButton_icon__D5JKP LoginButton_hideBelowMd__X7RkO LoginButton_anonymous__sPS3Y"
                  >
                    <path
                      d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <a href="/cart" className="cart_container">
              <svg
                aria-hidden="true"
                focusable="false"
                height="1em"
                role="presentation"
                width="1em"
                viewBox="0 0 24 24"
                className="svg_9c8206b6 Cart_shoppingCart__fdxFv"
              >
                <path
                  d="M14.8408 11H7.25989L6.14057 13H17.3338C17.8935 13 18.3514 13.45 18.3514 14C18.3514 14.55 17.8935 15 17.3338 15H6.14057C4.59386 15 3.617 13.37 4.35982 12.03L5.73354 9.59L2.07029 2H1.05272C0.493062 2 0.0351562 1.55 0.0351562 1C0.0351562 0.45 0.493062 0 1.05272 0H3.36261L7.69745 9H14.8408L18.1275 2.9C18.3921 2.41 19.0128 2.22 19.5114 2.49C19.9999 2.75 20.1728 3.35 19.9184 3.83L16.6215 9.97C16.2756 10.59 15.604 11 14.8408 11ZM6.14058 16C5.02125 16 4.11562 16.9 4.11562 18C4.11562 19.1 5.02125 20 6.14058 20C7.2599 20 8.17572 19.1 8.17572 18C8.17572 16.9 7.2599 16 6.14058 16ZM16.3163 16C15.1969 16 14.2913 16.9 14.2913 18C14.2913 19.1 15.1969 20 16.3163 20C17.4356 20 18.3514 19.1 18.3514 18C18.3514 16.9 17.4356 16 16.3163 16Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>

          <button className="menu_button" type="button">
            <svg
              aria-hidden="true"
              focusable="false"
              height="1em"
              role="presentation"
              width="1em"
              viewBox="0 0 24 24"
              className="svg_9c8206b6"
            >
              <path
                d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
                fill="currentColor"
              />
            </svg>
            <span>Menu</span>
          </button>

          <div className="main_search">
            <div className="result_container">
              <form action="." className="search_form">
                <input
                  type="text"
                  className="search_input"
                  placeholder="Look for a product, brand or some advice"
                />
                <button className="search_button" type="button">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    height="1em"
                    role="presentation"
                    width="1em"
                    viewBox="0 0 24 24"
                    className="svg_9c8206b6 SearchForm_magnifyingGlassIcon__l1Sim"
                  >
                    <path
                      d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 001.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 00-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 005.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </form>
            </div>
          </div>

          <nav className="navbar">
            <div className="root">
              <div>
                <a href="/sales" className="sales">
                  <span>Sales</span>
                </a>
              </div>
              <div>
                <a href="/best-sallers">Great deals</a>
              </div>
              <div>
                <a href="/best-sallers">Best sellers</a>
              </div>
              <div>
                <a href="/drills">Drills</a>
              </div>
              <div>
                <a href="/workshop">Workshop furniture and accessories</a>
              </div>
              <div>
                <a href="/electric">Electric heaters and radiators</a>
              </div>
              <div>
                <a href="/bookcases">Bookcases and shelves</a>
              </div>
              <div>
                <a href="/lights">Pendant lights</a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
